import Papa from "papaparse";

/**
 * Exports an array of objects to CSV
 * @param {Array} data - The data to export
 * @param {string} fileName - The name of the downloaded file
 */
export const exportToCSV = (data, fileName = "export.csv") => {
  if (!data || !data.length) return;

  const csv = Papa.unparse(data);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
